import React, { useEffect } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"


const Logout = () => {
 

  useEffect(() => {
    // Remove the auth token from localStorage
    localStorage.removeItem("auth")
    localStorage.removeItem("role")
    localStorage.removeItem("username")

    // Redirect to the login page
    window.location.href = '/login'
  }, [])

  return null // No UI needed for this component
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
